module.exports = __webpack_public_path__ + "static/img/logo.ce7c0d17.png";